import React from 'react';
import AdminResourceManagerPage from '../../components/admin/AdminResourceManagerPage';

export default function AdminHomepageEditaisPage() {
  return (
    <AdminResourceManagerPage
      moduleKey="homepageEditais"
      title="Oportunidades e Editais"
      description="Gerencie os editais exibidos na página inicial, com arquivo em PDF ou link de referência."
      createLabel="Novo edital"
      emptyMessage="Nenhum edital cadastrado no momento."
      supportsTag
    />
  );
}
